import { Box, Typography } from "@mui/material";
import { ReactComponent as Arrow } from "../../../assets/icons/solid_interface_caret_down.svg";

export default function FilterButton({ length, title }) {
  return (
    <>
      <Box
        ml={1}
        sx={{
          minHeight: 32,
          px: "8px",
          py: "4px",
          borderRadius: "8px",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          bgcolor: "common.white",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="button" mr={1} color="primary.main">
          {title}
        </Typography>

        {length && (
          <div>
            <Typography
              variant="subtitle"
              color="grey.4"
              fontSize={12}
              mr={1}
              px={0.75}
              sx={{
                borderRadius: "50%",
                backgroundColor: "grey[10]",
              }}
            >
              {length}
            </Typography>
          </div>
        )}
        <Arrow width={9} height={9} />
      </Box>
    </>
  );
}
